import { useMemo, useState } from "react";
import MyDropdown from "../../../../Common/my-dropdown/my-dropdown-new.component";
import PlusIcon from "../../../../icons/plus.icon";
import { AddToolDropdownMenu } from "./add-tool-dropdown.menu";
import "./add-tool.dropdown.scss";
import useSelectToolSearchData from "../../select-tool-search.data";

export interface Integration {
  IntegrationId: number;
  IntegrationName: string;
  ToolIcon: string;
  IsCustom: boolean;
  IsPractice: boolean;
}

interface IAddToolDropdown {
  tool: any;
  showOnlyPracticeTools?: boolean;
  showToolsInStack?: boolean;
  addNewIntegration: (technologyEnum: string, IntegrationId: string, toolName: string, selected: boolean, isPractice: boolean) => any;
  technologyAnswerState?: ({ technologyEnum, value }: { technologyEnum: string, value: boolean }) => any;
  onNewTool?: (tool: any) => void;
  onStackToolClick?: (integration: Integration) => void;
}

const AddToolDropdown = ({ tool, addNewIntegration, technologyAnswerState, onNewTool, showOnlyPracticeTools = false, onStackToolClick, showToolsInStack = true }: IAddToolDropdown) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isAnswerNoLoading, setIsAnswerNoLoading] = useState(false);

  const {
    data: modalToolsList,
    isLoading: isModalToolsListLoading,
    getIntegrations: getModalIntegrations
  }: any = useSelectToolSearchData({ techTypeEnum: tool?.TechnologyEnum, showAll: true, searchText: "" });

  const filteredToolsList = useMemo(() => {
    return modalToolsList?.Integration_List
      ?.filter((item: Integration) => 
        searchQuery 
          ? item.IntegrationName.toLowerCase().includes(searchQuery.toLowerCase())
          : true
      );
  }, [modalToolsList, searchQuery]);

  const filteredSecurityStackToolsList = useMemo(() => {
    return modalToolsList?.SecurityStack_List
      ?.filter((item: Integration) => 
        searchQuery 
          ? item.IntegrationName.toLowerCase().includes(searchQuery.toLowerCase())
          : true
      );
  }, [modalToolsList, searchQuery]);

  const handleOpen = (isOpen: boolean) => {
    if (isOpen) {
      getModalIntegrations();
    }
    setSearchQuery('');
  };

  const handleAddTool = async (integration: Integration) => {
    const res = await addNewIntegration(tool?.TechnologyEnum, integration?.IntegrationId?.toString(), integration?.IntegrationName, true, integration?.IsPractice);
    getModalIntegrations();
    document.body.click();
    return res;
  };

  const handleStackToolClick = (integration: Integration) => {
    onStackToolClick?.(integration);
    document.body.click();
  };

  const handleAnswerNo = () => {
    if (searchQuery) {
      document.body.click();
      onNewTool?.({
        ToolName: searchQuery,
        IsCustom: true,
      });
      return;
    }
    setIsAnswerNoLoading(true);
    technologyAnswerState?.({ technologyEnum: tool?.TechnologyEnum, value: true }).finally(() => {
      setIsAnswerNoLoading(false);
    });
  };

  return (
    <MyDropdown onToggle={handleOpen}>
      <MyDropdown.Toggle hideArrow>
        <div className="my-button styled justify-content-start d-flex align-items-center f-grey">
          <div className="left-icon">
            <PlusIcon fill="#616778" />
          </div>
          <span className="f-12 line-height-18 f-500">Add</span>
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu className="add-tool-dropdown-menu">
        <AddToolDropdownMenu 
          toolsList={filteredToolsList} 
          toolsInStackList={filteredSecurityStackToolsList}
          showToolsInStack={showToolsInStack}
          searchQuery={searchQuery} 
          onSearchChange={setSearchQuery} 
          isLoading={isModalToolsListLoading} 
          onAddTool={handleAddTool} 
          onStackToolClick={handleStackToolClick}
          answerNo={handleAnswerNo} 
          isAnswerNoLoading={isAnswerNoLoading}
          showOnlyPracticeTools={showOnlyPracticeTools}
        />
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default AddToolDropdown;

